<template>
  <div class="contact">
    <item v-for="item in items" v-bind="item" :key="item.title" />
  </div>
</template>
<script>
/* eslint-disable */
import item from "./item.vue";

export default {
  components: { item },
  data() {
    return {
      sections: [
        {
          title: "Salg og Kundeservice",
          phone: "+45 44 97 14 00",
          mail: "stila@stila.dk",
          people: [
          {
              img: "/img/contact/jesper-n.jpg",
              name: "Jesper Nielsen",
              title: "Sales Manager",
              phone: "53554680",
              email: "jn@stila.dk",
            },
            {
              img: "/img/contact/charlotte.jpg",
              name: "Charlotte List",
              title: "Salg – nord og vest",
              phone: "28117873",
              email: "cl@stila.dk",
            },  
		  	{
              img: "/img/contact/helle-n.jpg",
              name: "Helle Noltensmeier",
              title: "Salg – øst",
              phone: "28295918",
              email: "hn@stila.dk",
            },
            {
              img: "/img/contact/mads-a.jpg",
              name: "Mads Ahlmann",
              title: "Salg – syd og vest",
              phone: "28438285",
              email: "ma@stila.dk",
            },
            {
              img: "/img/contact/annie.jpg",
              name: "Annie Jensen",
              title: "Kundeservice",
              phone: "44821119",
              email: "annie@stila.dk",
            },
            {
              img: "/img/contact/helle-h.jpg",
              name: "Helle Hassenkam",
              title: "Kundeservice",
              phone: "44821161",
              email: "hh@stila.dk",
            },
            {
              img: "/img/contact/jannie.jpg",
              name: "Jannie Højriis Riber",
              title: "Kundeservice",
              phone: "44821114",
              email: "jhr@stila.dk",
            },
            {
              img: "/img/contact/karina-a.jpg",
              name: "Karina Andersen",
              title: "Kundeservice",
              phone: "44821159",
              email: "ka@stila.dk",
            },
            {
              img: "/img/contact/jesper-carlsen.jpg",
              name: "Jesper Carlsen",
              title: "Servicemontør",
              phone: "44821118",
              email: "jc@stila.dk",
            },
            {
              img: "/img/contact/lone.jpg",
              name: "Lone Andersen",
              title: "Produkt Tekniker",
              phone: "44821166",
              email: "lone@stila.dk",
            },
          ],
        },
        {
          title: "Marketing og Produkt",
          phone: "+45 44 82 11 02",
          mail: "support@stila.dk",
          people: [
            { 
              img: "/img/contact/karina-w.jpg",
              name: "Karina Wiinblad",
              title: "Marketingassistent",
              phone: "44821152",
              email: "karina@stila.dk",
            },
            {
              img: "/img/contact/johan.jpg",
              name: "Johan Ulrichs Olsen",
              title: "Product Manager",
              phone: "44821153",
              email: "juo@stila.dk",
            },
            // {
            //   img: "/img/contact/laila-petersen.jpg",
            //   name: "Laila Petersen",
            // },
          ],
        },
        {
          title: "Bogholderi og administration",
          phone: "+45 44 82 11 54",
          mail: "bogholderi@stila.dk",
          people: [
            {
              img: "/img/contact/laila.jpg",
              name: "Laila Petersen",
              title: "Head of Finance and HR",
              phone: "44821151",
              email: "lp@stila.dk",
            },
            {
              img: "/img/contact/ann-j.jpg",
              name: "Ann Jacobsen",
              title: "Kreditorbogholder",
              phone: "44821150",
              email: "aj@stila.dk",
            },
            {
              img: "/img/contact/lene.jpg",
              name: "Lene Refer",
              title: "Debitorbogholder",
              phone: "44821108",
              email: "lene@stila.dk",
            },
          ],
        },
      ],
    };
  },
  computed: {
    reseller: (t) => t.$store.getters["user/employee"],

    header: (t) => ({
      type: "header",
      title: "Din Kontaktperson",
      phone: t.reseller.phone,
      mail: t.reseller.email,
      people: [
        {
          img: t.reseller.image ? { src: t.reseller.image.url } : null,
          name: t.reseller.name,
          title: t.reseller.title,
          phone: t.reseller.phone,
          email: t.reseller.email,
        },
      ],
    }),

    items: (t) =>
      [t.reseller ? t.header : null, ...t.sections].filter((x) => x),
  },
};
</script>

<style lang="scss" scoped></style>
